import { render, staticRenderFns } from "./FavoriteMessageItem.vue?vue&type=template&id=6512cec9&scoped=true"
import script from "./FavoriteMessageItem.vue?vue&type=script&lang=js"
export * from "./FavoriteMessageItem.vue?vue&type=script&lang=js"
import style0 from "./FavoriteMessageItem.vue?vue&type=style&index=0&id=6512cec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512cec9",
  null
  
)

export default component.exports